var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.selectedClass + 'tab',on:{"click":function($event){return _vm.selectTab($event)}}},[_c('p',{staticClass:"sm-text-highlight-upper"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }